/**
 * Check if a string matches UUID format
 */
export const isUUID = (value) => {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value);
};
//# sourceMappingURL=uuid.type.js.map